'use strict';

import Backbone from 'backbone';
import BuyingOptionModel from '../BuyingOptions/BuyingOptionModel';


export default class SingleBuyingOptionCollection extends Backbone.Collection {
  get model() {
    return BuyingOptionModel;
  }

  initialize() {
    // Cache addToCart options until collection is changed
    this.addToCartOptions = null;
    this.on('update', () => this.addToCartOptions = null);
  }

  firstAddToCart() {
    return this.findWhere({ type: 'AddToCart' });
  }

  /**
   * Get just the addToCartOptions.
   *
   * @returns {SingleBuyingOptionCollection|null}
   */
  getAddToCartOptions() {
    if (!this.addToCartOptions) {
      this.addToCartOptions = new SingleBuyingOptionCollection(this.where({ type: 'AddToCart' }));
    }

    return this.addToCartOptions;
  }
}



// WEBPACK FOOTER //
// ./assets/components/SingleBuyingOptions/SingleBuyingOptionCollection.js